const m = {
  'Aggiungi una modalità di pagamento': 'Add a payment method',
  'Chiudi': 'Close',
  'Caricamento…': 'Loading…',
  'Seleziona il metodo di pagamento da aggiungere:': 'Select the payment method to add:',
  'Carta bancaria': 'Bank card',
  'Consigliato': 'Recommended',
  'Nome del titolare': 'Cardholder name',
  'Nome Cognome': 'First name Last name',
  'Numero di carta': 'Card number',
  'Data di scadenza': 'Expiry date',
  'Codice di sicurezza': 'Security code',
  'Definire questo metodo di pagamento come predefinito': 'Set this payment method as default',
  'La carta viene verificata subito, ': 'The card is verified immediately, ',
  'senza alcun addebito': 'with no charge',
  '. Verrà usata per il rinnovo dei tuoi prodotti e il pagamento delle fatture.': '. It will be used to renew your products and pay your invoices.',
  'Non ancora disponibile': 'Not yet available',
  'Annullare': 'Cancel',
  'Attendere…': 'Please wait…',
  'Aggiungi': 'Add',
  'Carta non verificata.': 'Card not verified.',
  'Verifica della carta non completata.': 'Card verification not completed.',
  'Errore durante il salvataggio della carta. Riprova.': 'An error occurred while saving the card. Please try again.',
  'Configurazione dei pagamenti non disponibile.': 'Payment configuration not available.',
  "Impossibile inizializzare l'aggiunta della carta. Riprova.": 'Unable to initialize adding the card. Please try again.',
};
export default m;
